import { defineComponent, ref } from "vue";
import Swal from "sweetalert2";
import { useRouter, useRoute } from "vue-router";
import { authService } from "@/services/AuthService";
import Header from "@/components/Header.vue";
export default defineComponent({
    components: {
        Header,
    },
    setup() {
        const route = useRoute();
        const router = useRouter();
        const password = ref("");
        const confirmPassword = ref("");
        const loading = ref(false);
        const message = ref("");
        const messageType = ref("");
        const passwordError = ref(false);
        const confirmPasswordError = ref(false);
        const succesToast = Swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            customClass: {
                popup: "success-toast", // Clase personalizada para el toast de error
            },
            didOpen: (toast) => {
                toast.addEventListener("mouseenter", Swal.stopTimer);
                toast.addEventListener("mouseleave", Swal.resumeTimer);
            },
        });
        // Obtener el token desde los parámetros de la URL
        const token = route.query.token;
        // Validación de Contraseña
        const validatePassword = () => {
            const regex = /^(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/;
            return regex.test(password.value);
        };
        // Restablecer Contraseña
        const resetPassword = async () => {
            if (!validatePassword()) {
                passwordError.value = true;
                return;
            }
            if (password.value !== confirmPassword.value) {
                confirmPasswordError.value = true;
                return;
            }
            passwordError.value = false;
            confirmPasswordError.value = false;
            loading.value = true;
            try {
                if (!token) {
                    message.value = "No se encontró el token en la URL.";
                    messageType.value = "error";
                    return;
                }
                // Llamada al servicio para restablecer la contraseña
                const response = await authService.resetPassword(token, password.value);
                if (response.exito) {
                    succesToast.fire({
                        text: "Contraseña restablecida con éxito",
                        icon: "success",
                    });
                    // Redirigir a /producto
                    router.push("/login");
                }
            }
            catch (error) {
                message.value = "Ocurrió un error al restablecer la contraseña.";
                messageType.value = "error";
            }
            finally {
                loading.value = false;
            }
        };
        return {
            password,
            confirmPassword,
            loading,
            message,
            messageType,
            passwordError,
            confirmPasswordError,
            resetPassword,
        };
    },
});
